import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CompanyPageChooseJobBoardCredentialTypeModalComponent } from './company-page-choose-job-board-credential-type-modal.component';

@NgModule({
  declarations: [CompanyPageChooseJobBoardCredentialTypeModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot()
  ],
  exports: [CompanyPageChooseJobBoardCredentialTypeModalComponent],
  entryComponents: [CompanyPageChooseJobBoardCredentialTypeModalComponent]
})
export class CompanyPageChooseJobBoardCredentialTypeModalModule { }
